import { CSSProperties, MouseEventHandler } from "react";
import "./ButtonElement.scss";
import { CircularProgress } from "@mui/material";

interface ButtonElementProps {
  secondary?: boolean;
  children?: string | React.ReactNode;
  modal?: boolean;
  iconL?: boolean;
  iconR?: boolean;
  iconName?: string;
  disabled?: boolean;
  link?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  type?: "button" | "submit";
  styles?: CSSProperties;
}
export const ButtonElement = ({
  secondary,
  children,
  modal,
  iconL,
  iconR,
  iconName,
  disabled,
  onClick,
  link,
  isLoading = false,
  type = "submit",
  styles,
}: ButtonElementProps) => {
  return (
    <>
      <button
        type={type}
        className={`${link ? "link" : ""} ${
          secondary ? "secondary" : "primary"
        } ${modal ? "modal" : ""} button-element button`}
        disabled={isLoading || disabled}
        onClick={onClick}
        style={{ ...styles }}
      >
        <span
          className={`${iconL ? "" : "d-none"} ${iconName}`}
          aria-hidden="true"
        />
        <span className="text-button">{children}</span>
        <span
          className={`${iconR ? "" : "d-none"} ${iconName}`}
          aria-hidden="true"
        />
        {isLoading && (
          <CircularProgress
            color={"error"}
            style={{ width: "24px", height: "24px" }}
          />
        )}
      </button>
    </>
  );
};

export default ButtonElement;
